import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_CRAFTSMEN`:
            return core.setCraftsmen(state, action.craftsmen);
        case `${env.toUpperCase()}__UPDATE_CRAFTSMEN`:
            return core.updateCraftsmen(state, action.craftsmen);
        case `${env.toUpperCase()}__SET_CRAFTSMAN`:
            return core.setCraftsman(state, action.craftsmanId, action.craftsman);
        case `${env.toUpperCase()}__UPDATE_CRAFTSMAN`:
            return core.updateCraftsman(state, action.craftsmanId, action.craftsman);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Craftsman/reducer.js